
const ChosenPlan = ({id=2, children}) => {
  return id === 2 ? "" : children
}
export default ChosenPlan